<template>
	<div class="team-social-mobile">
		<ul class="list-unstyled sharing-icons">
			<li class="sharing-icons__container" @click="showIcons = !showIcons">
				<font-awesome-icon v-if="!showIcons" :icon="['custom', 'share']" />
				<font-awesome-icon
					v-else
					:icon="['custom', 'close']"
					:class="{ 'active-icon': showIcons }"
				/>
				<transition name="slide-fade">
					<div v-if="showIcons" class="share-icons">
						<SocialShareButtons
							:url="sharingUrl"
							:title="sharing.title"
							:image="sharing.twitterimage"
							:networks="['linkedin','facebook','twitter','pinterest','instagram','behance']"
						/>
					</div>
				</transition>
			</li>
			<li v-if="contact && contact.VCard">
				<a :href="contact.VCard" download target="_blank" rel="noopener"
					><font-awesome-icon :icon="['custom', 'download']"
				/></a>
			</li>
			<li v-if="contact.Downloads && contact.Downloads.length">
				<a
					download
					target="_blank"
					rel="noopener"
					:href="completePDFUrl(contact.Downloads[0].url)"
					><font-awesome-icon :icon="['custom', 'pdf']"
				/></a>
			</li>
			<li v-if="contact && contact.Email">
				<a :href="`mailto:${contactEmail}`"
					><font-awesome-icon :icon="['custom', 'mail']"
				/></a>
			</li>
			<li v-if="contact && contact.Phone">
				<a :href="`tel:${contact.Phone}`"
					><font-awesome-icon :icon="['custom', 'phone']"
				/></a>
			</li>
		</ul>
	</div>
</template>

<script>
import { useRuntimeConfig } from '#app'
import SocialShareButtons from '~/components/Common/SocialShareButtons.vue'
export default {
	name: 'TeamsListSocialSharing',
	components: { SocialShareButtons },
	// eslint-disable-next-line vue/require-prop-types
	props: ['contact'],
	data() {
		return {
			showIcons: false,
			contactEmail: 'booking@cromatics.de',
			networks: []
		}
	},
	computed: {
		sharingUrl() {
			if (this.contact && this.contact.ID && typeof window !== 'undefined') {
				const baseUrl = window.location.origin
				const contactUrl = `/contact/${this.contact.ID}`
				return `${baseUrl}${contactUrl}`
			}
			return ''
		},
		sharing() {
			const title = this.contact?.Firstname || ''
			const description = this.contact?.TeaserText || ''
			const media = this.contact?.TeaserImage || ''
			return { url: this.sharingUrl, title, description, twitterimage: media }
		},
	},
	methods: {
		completePDFUrl(pdfPath) {
			if (!pdfPath) return ''
			if (pdfPath.startsWith('http://') || pdfPath.startsWith('https://')) return pdfPath
			return usePimcoreAssetUrl(pdfPath)
		}
	}
}
</script>
<style lang="scss">
.team-social-mobile {
	.share-icons {

	}
}
</style>
